import { render, staticRenderFns } from "./ModalImportTabsDesigns.vue?vue&type=template&id=6ed1866d"
import script from "./ModalImportTabsDesigns.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalImportTabsDesigns.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports